/* eslint-disable react-hooks/static-components */
import type { ComponentType, JSX, SuspenseProps } from 'react';
import { lazy, Suspense, useMemo } from 'react';

import { Spinner } from '@change/ds-core-ui';

import { ClientRender } from '@change-corgi/core-react/ssr/render';

type Props<COMP_PROPS extends Record<string, unknown> = EmptyProps> = COMP_PROPS & {
	loadComponent: () => Promise<ComponentType<COMP_PROPS>>;
	fallback?: SuspenseProps['fallback'];
};

export function LazyComponent<COMP_PROPS extends Record<string, unknown> = EmptyProps>({
	loadComponent,
	fallback = <Spinner className="mx-auto" />,
	...compProps
}: Props<COMP_PROPS>): JSX.Element {
	const LazyComponentInner = useMemo(
		() =>
			lazy(async () => ({
				default: await loadComponent(),
			})),
		[loadComponent],
	);

	return (
		<ClientRender>
			<Suspense fallback={fallback}>
				{/* oxlint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions */}
				<LazyComponentInner {...(compProps as any)} />
			</Suspense>
		</ClientRender>
	);
}
